import React, { useLayoutEffect, useState } from 'react';

export default function useScreenSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      );
      const vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      );
      setSize([vw, vh]);
    }

    window.screen.orientation.addEventListener('change', updateSize);
    window.addEventListener('resize', updateSize);
    updateSize();

    return () => {
      window.removeEventListener('resize', updateSize);
      window.screen.orientation.removeEventListener('change', updateSize);
    };
  }, []);
  return size;
}
